import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

export const authGuard: CanActivateFn = (): boolean | UrlTree => {
  const router = inject(Router);

  const hasToken = !!localStorage.getItem('auth_token') || !!localStorage.getItem('refresh_token');

  if (hasToken) {
    return true;
  }

  return router.parseUrl('login');
};
